import { ActionTree } from 'vuex';
import { RootState } from '../../types';
import { TrainerPaymentState } from './types';
import { Logger } from 'fsts';
import { defaultBackendTrainerPayment } from '@/shared/backend/trainerPayment';
import moduleUtils from '../moduleUtils';
import { TrainerPayment } from '@/shared/model/trainerPayment';
import { i18nGlobal } from '@/i18n';

const logger = new Logger('actions.trainerPayments');
export const actions: ActionTree<TrainerPaymentState, RootState> = {
  getTrainerPayments(
    { commit, getters },
    payload: {
      searchParams?: any;
      trainerId: string;
      date?: string;
      noStore?: boolean;
    }
  ) {
    commit('setTrainerPaymentsIsLoading', true);
    const searchParams =
      payload?.searchParams ?? getters.getTrainerPaymentsSearchParams;

    return defaultBackendTrainerPayment
      .getTrainerPayments(searchParams, payload.trainerId, payload.date)
      .then((resp) => {
        if (payload?.noStore) return resp.data;
        commit('setTrainerPayments', resp.data);
        return resp.data;
      })
      .catch((err) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      })
      .finally(() => {
        commit('setTrainerPaymentsIsLoading', false);
      });
  },
  updateTrainerPayment({ commit }, trainerPayment: TrainerPayment) {
    return defaultBackendTrainerPayment
      .updateTrainerPayment(trainerPayment)
      .then((resp) => {
        moduleUtils.ok(i18nGlobal.t(`success.trainer_payment_update`), commit);
        return resp.data;
      })
      .catch((err: any) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      });
  },
  deleteTrainerPayment({ commit }, id: string) {
    return defaultBackendTrainerPayment
      .deleteTrainerPayment(id)
      .then((resp) => {
        moduleUtils.ok(
          i18nGlobal.t(`success.trainer_payment_deletion`),
          commit
        );
        return resp.data;
      })
      .catch((err: any) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      });
  },
  checkForOverlappingTrainerPayments(
    { commit },
    trainerPayment: TrainerPayment
  ) {
    return defaultBackendTrainerPayment
      .checkForOverlappingTrainerPayments(trainerPayment)
      .then((resp) => {
        return resp.data;
      })
      .catch((err: any) => {
        moduleUtils.error('error', commit, err, logger);
        throw err;
      });
  },
};
